import type { ComponentType } from "react";
import type { NodeProps, NodeTypes } from "@xyflow/react";
import { RuleGraphNodeCard } from "./RuleGraphNodeCard";
import { RuleGraphCartInputNode } from "./RuleGraphCartInputNode";

export const RULE_GRAPH_NODE_TYPES: NodeTypes = {
  ruleGraphNode: RuleGraphNodeCard as ComponentType<NodeProps>,
  ruleGraphCartInput: RuleGraphCartInputNode as ComponentType<NodeProps>,
};
